import type { IColumnInfo } from '@dbl/core/dataSource';
import { MetricOptions } from '@dbl/core/dataSource';
import moment from 'moment/moment';
import { DateGranularity } from '@dbl/core/date';
import {
  TDispatchFun,
  SortableItems,
} from '@/pages/datalab/components/SortableDrag/configration';
import { DragState } from '@/pages/datalab/components/SortableDrag/typeDefine';
import { ErrorDragType } from '@dbl/core/chartEditor';
import {Options} from "@/pages/dashboard/components/SelectorMultiple/types";
import {useState} from "react";

const FORMAT_TIME = 'YYYY-MM-DD';
const FORMAT_HOUR = 'YYYY-MM-DD HH:mm';
export const moment2StringEx = (time: moment.Moment, granularity: string) =>
  moment2String(time, granularity === DateGranularity.HOUR ? FORMAT_HOUR : FORMAT_TIME);
export const moment2String = (time: moment.Moment, format?: string | undefined) => time.format(format || FORMAT_TIME);
export const string2Moment = (timeStr: string) => moment(timeStr);

export const initDragStatus = (dispatchFun: TDispatchFun) => {
  dispatchFun('saveDrag', {});
};

export const dragOnMove = (
  evt: any,
  originalEvent: any,
  sortableKey: string,
  columnInfos: IColumnInfo[],
  dispatchFun: TDispatchFun,
  currentDragItem: IColumnInfo | null,
) => {
  const { to, from } = evt;
  let tempCurrentDrag = '';
  let tempCurrentDragErrorType = '';
  if (to.className.includes(`${sortableKey}-${SortableItems}`) && to !== from) {
    if (
      (to.className.includes('filter-content') || to.className.includes('dimensions-content')) &&
      currentDragItem?.column_sensitive === true
    ) {
      // 在过滤条件和维度中不允许添加 敏感字段
      tempCurrentDragErrorType = ErrorDragType.Sensitive;
    } else {
      const result = currentDragItem
        ? columnInfos?.every(
          (item) => item.column_name !== currentDragItem?.column_name || currentDragItem?.table_id !== item.table_id || currentDragItem?.table_code !== item.table_code,
        )
        : true;
      // 已添加过该字段
      tempCurrentDragErrorType = result ? '' : ErrorDragType.Same;
      
      // if (columnInfos.length >= 11) {
      //   tempCurrentDragErrorType = ErrorDragType.Max;
      // }
    }
    
    // else if (
    //   to.className.includes('filter-content') &&
    //   currentDragItem?.column_custom === true &&
    //   stringType.values.includes(currentDragItem?.column_type ?? '')
    // ) {
    //   // 部分不支持过滤的自定义字段
    //   tempCurrentDragErrorType = ErrorDragType.Custom;
    // }
    
    
    tempCurrentDrag = sortableKey;
  }
  const dragState: DragState = {
    currentDrag: tempCurrentDrag,
    errorDrag: { [sortableKey]: tempCurrentDragErrorType },
    currentDragItem,
  };
  dispatchFun('saveDrag', { dragState });
  return true;
};

export const includeOperation = (operation: string | undefined) => operation === 'include' || operation === 'exclude';
export const metricOptionText = (aggregate: string | undefined, isEn: boolean) =>
  aggregate ? MetricOptions.find((item: any) => item.value === aggregate)?.[isEn ? "text_en" : "text"] ?? '' : (isEn ? 'Aggregated' : '已聚合');

export const validateColumns = (props: any, dispatch: Function, columnList: string[]) => {
  const { dragState }: { dragState: DragState; } = props;
  const { errorDrag } = dragState;
  let findEmpty = false;
  columnList.forEach((itemName) => {
    const { [itemName]: valueList } = props;
    if (valueList.length === 0) {
      findEmpty = true;
      errorDrag[itemName] = ErrorDragType.Empty;
    }
  });
  dispatch('save', {
    payload: {
      dragState: {
        ...dragState,
        errorDrag,
      },
    },
  });
  return !findEmpty;
};

export const confirmColumns = (props: any, dispatch: Function, columnList: string[]) => {
  const { dragState }: { dragState: DragState; } = props;
  const { errorDrag } = dragState;
  columnList.forEach((itemName) => {
    const { [itemName]: valueList } = props;
    if (valueList.length === 0) {
      errorDrag[itemName] = ErrorDragType.Empty;
    }
  });
  dispatch('save', {
    payload: {
      dragState: {
        ...dragState,
        errorDrag,
      },
    },
  });
};


export const useSearch = (options: Options) => {
  const [searchValue, setSearchValue] = useState('');
  
  const searchValueEscape = (searchValue) => {
    const specialCharacter = ['\\', '$', '(', ')', '*', '+', '.', '[', '?', '^', '{', '|'];
    specialCharacter.forEach(str => {
      const reg = new RegExp(`\\${  str}`, 'gim');
      // eslint-disable-next-line no-param-reassign
      searchValue = searchValue?.replace?.(reg, `\\${  str}`);
    });
    
    return searchValue;
  };
  
  const replaceMatch = (text, _searchValue = searchValue) => {
    _searchValue = searchValueEscape(_searchValue);
    const reg = new RegExp(`${_searchValue}`, 'gi');
    const setText = (text) => `<span style='color: #006EFF'>${text}</span>`;
    return text?.replace?.(reg, (matchText) => setText(matchText));
  };
  
  const buildHighLightData: () => Options = () => {
    // 无 searchValue 展示全部
    if (!searchValue) return options;
    
    const renderOptions = options?.map(option => {
      const filterText = replaceMatch(option?.text);
      
      // 过滤掉不包含 searchValue 的项
      if (option.text === filterText) return null;
      
      return {
        ...option,
        text: filterText
      };
    });
    return renderOptions?.filter(item => item !== null) as Options;
  };
  
  return {
    searchValue,
    setSearchValue,
    replaceMatch,
    buildHighLightData,
  };
};

export const getActionState = (oldState, newState) => {
  
  if (newState.length > oldState.length) {
    // 新增
    
    return {
      actionType: 'add',
    };
  }
  
  // if ()
  
};